import HeaderBar from "../../../Components/UI/headerbar";
import PaymentMethodsTab from "../components/PaymentMethodsTab";

const PaymentMethodsPage = () => {

  return (
    <div className="container-fluid">
      <HeaderBar
        title="إدارة الماليات"
        content="إدارة المدفوعات والعمولات والمدفوعات."
      />
      <PaymentMethodsTab />
    </div>
  );
};

export default PaymentMethodsPage;
